// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2hj09","name":"styles_name__3ttJv","phone":"styles_phone__JLIGv"};